'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { makeLoadableModal } from 'AdsUI/lib/makeLoadable';
import ScopeWrapper from 'AdsUI/components/ScopeWrapper';
import UIButton from 'UIComponents/button/UIButton';

const makeLoadableAdWordsEditButton = (loader, message) => {
  const ModalContainerLoader = makeLoadableModal(loader);

  const LoadableButton = props => {
    const [modalOpen, setModalOpen] = useState(false);
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(ScopeWrapper, {
        tooltipKey: "editAds",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "tertiary-light",
          size: "extra-small",
          responsive: false,
          onClick: () => setModalOpen(true),
          children: message
        })
      }), modalOpen && /*#__PURE__*/_jsx(ModalContainerLoader, Object.assign({
        closeModal: () => setModalOpen(false)
      }, props))]
    });
  };

  return LoadableButton;
};

export default makeLoadableAdWordsEditButton;